import { getToken} from '@/utils/auth'
import { makerlogins,loginSmsVerifyCode } from '@/api/login'
// import axios from 'axios'
const state = {
    token: getToken(),
    name: '',
    avatar: '',
    roleType: '',
    userId: '',
    makerId:'',
    dutyList: [],
    menuList: [],
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, makerName) => {
        state.makerName = makerName
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_ROLE: (state,roleType) => {
        state.roleType = roleType
    },
    set_USERID: (state,userId) => {
        state.userId = userId
    },
    set_MAKERID: (state,makerId) => {
        state.makerId = makerId
    },
    set_DUTYLIST: (state,dutyList) => {
        state.dutyList = dutyList;
    },
    set_MENULIST: (state,menuList) => {
        state.menuList = menuList;
    }
}

const actions = {
    // user login
    setToken({commit},data){
        commit('SET_TOKEN', data.value)
    },
    loginphone({commit}, userInfo) {
        return new Promise((resolve, reject) => {
            loginSmsVerifyCode({
                phone: userInfo.phone,
                verifyCode: userInfo.verifyCode,
                agreementSelected: userInfo.agreementSelected,
            }).then(response => {
                let res = response.data;
                if(res.code == 200){
                    commit('SET_TOKEN', res.token);
                    commit('SET_ROLE',"r5");
                    //commit('SET_NAME',res.user.userNick);
                    commit('SET_NAME',res.user.userNick);
                    commit('set_MAKERID',res.user.makerId);
                    commit('set_DUTYLIST',res.user.dutyList);
                    commit('set_MENULIST',res.user.menuList);

                    localStorage.setItem('token',res.token);
                    localStorage.setItem('userNick',res.user.userNick);
                    localStorage.setItem('userImage',res.user.userImage);
                    localStorage.setItem('userPhone',res.user.userPhone);
                    localStorage.setItem('passInit',res.user.passInit);
                    localStorage.setItem('job',res.user.job);
                    localStorage.setItem('roleType',4);
                    localStorage.setItem('id',res.user.id);
                    //localStorage.setItem('userId',res.user.userId);
                    localStorage.setItem('makerId',res.user.makerId);
                    localStorage.setItem('userRoleId',res.user.userRoleId);
                    localStorage.setItem('dutyList',JSON.stringify(res.user.dutyList));
                    localStorage.setItem('menuList',JSON.stringify(res.user.menuList));
                    resolve(res)
                } else {
                    reject(res.msg)
                    
                }
                
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}